// extracted by mini-css-extract-plugin
export var filterIncDec = "_4e-0";
export var leftBorder = "_4e-1";
export var rightBorder = "_4e-2";
export var stringInput = "_4e-3";